import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

export default function Products({ products }) {
    const settings = {
        dots: false,
        className: 'align-items-center',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
    }
    return (
        <div className="container mx-auto mb-[4rem]">
            <div className="text-center space-y-8 p-5">
                <h3 className="font-bold text-[30px] leading-[39px] px-4 md:text-[40px] md:leading-[52px]">
                    <span className="olm-gradient-text mr-2">
                        Open Letter Marketing
                    </span>
                    <span>
                        offers a variety of direct mail products designed to
                        meet diverse marketing needs. Their range includes:
                    </span>
                </h3>

                <div className="md:grid hidden gap-5 md:grid-cols-2 lg:grid-cols-3 lg:max-w-none auto-rows-[1fr]">
                    {[...products] &&
                        [...products].map(({ product, image, description }) => {
                            return (
                                <div
                                    className="flex flex-col overflow-hidden rounded-[20px]"
                                    key={product.ID}>
                                    <div className="flex-shrink-0">
                                        <img
                                            className="h-60 w-full object-cover cursor-pointer"
                                            src={image.url}
                                            alt={product.post_title}
                                        />
                                    </div>
                                    <div className="px-6 py-8 flex items-center bg-white border border-[#d6d6d6] rounded-b-[20px] h-[-webkit-fill-available]">
                                        <a
                                            className="block space-y-2"
                                            href={`/product/${product.post_name}`}>
                                            <p className="text-[22px] leading-[25px] font-semibold">
                                                {product.post_title}
                                            </p>
                                            <p className="text-lg leading-[24px]">
                                                {description}
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            )
                        })}
                </div>

                <div className="md:hidden block mx-[2rem]">
                    <Slider {...settings}>
                        {[...products] &&
                            [...products].map(
                                ({ product, image, description }) => {
                                    return (
                                        <div key={product.ID} className="p-3">
                                            <div className="flex flex-col overflow-hidden rounded-[20px] shadow-[0_4px_12px_rgba(242,130,48,0.2)]">
                                                <div className="flex-shrink-0">
                                                    <img
                                                        className="h-52 w-full object-cover cursor-pointer"
                                                        src={image}
                                                        alt={product.post_title}
                                                    />
                                                </div>
                                                <div className="bg-olm-gradient-t-to-b p-[1px] pt-0 rounded-b-[20px]">
                                                    <div className="bg-white rounded-b-[20px]">
                                                        <div className="px-6 py-8">
                                                            <a
                                                                className="block space-y-2"
                                                                href={`/product/${product.post_name}`}>
                                                                <p className="text-[22px] leading-[25px] font-semibold">
                                                                    {
                                                                        product.post_title
                                                                    }
                                                                </p>
                                                                <p className="text-lg leading-[24px]">
                                                                    {
                                                                        description
                                                                    }
                                                                </p>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                },
                            )}
                    </Slider>
                </div>
            </div>
        </div>
    )
}
